export const reportTypes = Object.freeze({
	RAW_DATA: 1,
	CUSTOM_DATA: 2,
});
